import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { JwtGuard, PublicGuard } from '@core';

const routes: Routes = [
  { path: '', canActivate: [PublicGuard], loadChildren: () => import('./public/public.module').then(m => m.PublicModule) },
  { path: '', canActivate: [JwtGuard], loadChildren: () => import('./private/private.module').then(m => m.PrivateModule) }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewsRoutingModule { }
